import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsService } from '@delon/theme';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'header-support',
  template: `
    <div
      class="alain-default__nav-item hide-this"
      (click)="openUrl()"
      nz-tooltip
      nzTooltipTitle="Support Center"
      nzTooltipPlacement="bottom"
    >
      <i nz-icon nzType="question-circle"></i>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class HeaderSupportComponent {
  loading = false;
  constructor(private readonly settings: SettingsService) {}
  openUrl() {
    let country = this.settings.user['company'].country;

    if (country === 'PH') {
      window.open(
        `https://support.qne.com.ph/support/solutions/35000142932`,
        '_blank'
      );
    } else if (country === 'MM') {
      window.open(`https://qnemm.freshdesk.com/support/home`, '_blank');
    } else {
      window.open(
        `https://support.qne.com.my/support/solutions/81000205493`,
        '_blank'
      );
    }
  }
}
